// @ts-nocheck
/* eslint-disable */
import SceneMarkerPano from "./pano";

export default class SceneMarkerMapyPano extends SceneMarkerPano {
	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerMapyPano",
			type: "marker"
		};
	}
}
